import React, { Fragment, useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Card from '../../components/Card'; 

function TownPage() {
  const [town, setTown] = useState(null);
  const [relatedObjects, setRelatedObjects] = useState([]); 
  const [loadingRelatedObjects, setLoadingRelatedObjects] = useState(true); 
  const { plcid } = useParams(); 
  const uniqueObjectIds = new Set(); 

  const fetchTown = async () => {
    try {
      const response = await fetch(`/api/place/town/${plcid}`);
      if (!response.ok) {
        throw new Error('Network response was not ok ' + response.statusText);
      }
      const jsonData = await response.json();
      setTown(jsonData[0]); 


      const objectIds = Array.isArray(jsonData[0].obj_id) ? jsonData[0].obj_id : [jsonData[0].obj_id];

      for (const id of objectIds) {
        console.log(`Fetching related object with ID: ${id}`); 
        await fetchRelatedObject(id); 
      }
      
    } catch (err) {
      console.error(err.message);
    }
  };


  const fetchRelatedObject = async (id) => {
    try {
      const response = await fetch(`/api/item/${id}`);
      const jsonData = await response.json();


      const newObjects = Array.isArray(jsonData) ? jsonData : [jsonData];


      newObjects.forEach(newObj => {
        if (!uniqueObjectIds.has(newObj.obj_id)) {
          uniqueObjectIds.add(newObj.obj_id); 
          setRelatedObjects(prevObjects => [...prevObjects, newObj]); 
        }
      });

      setLoadingRelatedObjects(false);

      console.log("Updated relatedObjects:", relatedObjects);
    } catch (err) {
      console.error("Error fetching related objects:", err);
      setLoadingRelatedObjects(false); 
    }
  };

  useEffect(() => {
    fetchTown();
  }, [plcid]);

  if (!town) {
    return <p>Loading...</p>; 
  }

  return (
    <Fragment>
      <div className="detailpage">

      <h1>Town/District: {town.town_name}</h1>

      <div className="detailpage_desc">
      <div className="detailpg_data_row">
      <h4 className="detailpg_title">Parent City:</h4>
      <div className="place-list">
      <div className="place-item">
      <Link to={`../place/city/${town.city_id}`}>
        <span className="data-value"><h4>{town.city}</h4></span>
      </Link>
      </div>
    </div>
  </div>
</div>


<h4 id="rel_title">Related Objects</h4>
      <div className="related-objects">
      <div className="container">
      <div className="wrapper">
      <div className="csrow">
              {relatedObjects.map(object => {
                const media = object.media ? 'thumb_' + object.media.split(',')[0] : '';  
                
                return (
                  <Card
                    key={object.obj_id}
                    id={object.obj_id}
                    ref_id={object.ref_id}
                    title={object.title}
                    media={media}  
                    media_type={object.med_name}
                    project={object.prj_name}
                    record_date={object.record_date ? new Date(object.record_date).toLocaleDateString() : 'No date available'}
                  />
                );
              })}
            </div>            
        </div>
        </div>
        </div>
        </div>
    </Fragment>
  );
}

export default TownPage;
